/* global jQuery */

(function ($) {

$(document).ready(function() {

  let ww = $('body').width();
  $('.node-type-article .align-center').width(ww);
});

})(jQuery);
